export default {
  meta: {
    title: '机会点详情',
    parentPath: ['/storemanage'],
    url: '/storemanage/tap', // 埋点用，记录所属模块
    breadcrumbs: {
      path: ['/storemanage/tap'],
      name: ['机会点管理'],
    },
  },
};
